import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { useBrandingContent } from '@src/reducers/branding';
import { PromoInfoBox } from 'entities/Promo/ui/PromoInfoBox/PromoInfoBox';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';

interface Props {
  link: string;
  buttonColor?: ButtonProps['color'];
  className?: string;
  source: string;
  isUserFromGoogleSearch: boolean;
}

export const PromoDealRedirectToAppButton = ({
  link,
  buttonColor,
  source,
  isUserFromGoogleSearch,
  ...other
}: Props) => {
  const branding = useBrandingContent();

  return (
    <PromoInfoBox isUserFromGoogleSearch={isUserFromGoogleSearch} link={link} source={source}>
      <ToFullDealAdvertisingButton
        {...other}
        style={{
          width: '100%',
          color: '#fff',
          ...(isUserFromGoogleSearch ? undefined : branding.sponsor.buttonStyles),
        }}
        size={52}
        block
        variant="primary"
        link={link}
        color={buttonColor}
        source={source}
      >
        Получить займ в приложении
      </ToFullDealAdvertisingButton>
    </PromoInfoBox>
  )
};
